import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

import Tooltip from 'components/common/Tooltip';

const styles = theme => ({
  root: {
    marginTop: -4,
    marginBottom: -4,
  },
  checkboxError: {
    '& svg': {
      color: theme.palette.validation[500],
    },
  },
});

class CheckboxField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };

    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  onMouseOver() {
    this.setState({ hovered: true });
  }

  onMouseOut() {
    this.setState({ hovered: false });
  }

  render() {
    const {
      id,
      input,
      meta: { touched, error, active },
      label,
      className,
      labelClassName,
      errorPlacement,
      classes,
      ...otherProps
    } = this.props;
    const { hovered } = this.state;
    const errorVisible = (active && touched && Boolean(error)) ||
      (hovered && touched && Boolean(error));
    return (
      <FormControlLabel
        className={classNames(classes.root, className)}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        classes={{
          label: labelClassName,
        }}
        control={
          <Tooltip
            content={
              error ? (
                <Typography variant="subheading" color="secondary">
                  {error}
                </Typography>
              ) : ' '
            }
            open={errorVisible}
            placement={errorPlacement}
            color="white"
            disableFocusListener
            disableHoverListener
            disableTouchListener
          >
            <Checkbox
              className={classNames({
                [classes.checkboxError]: error && touched,
              })}
              name={input.name}
              checked={input.value || false}
              onChange={input.onChange}
              color="primary"
              inputProps={{
                id,
              }}
              {...otherProps}
            />
          </Tooltip>
        }
        label={label}
      />
    );
  }
}

CheckboxField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]).isRequired,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  errorPlacement: PropTypes.oneOf(['right', 'left', 'top', 'bottom']),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    checkboxError: PropTypes.string.isRequired,
  }).isRequired,
};

CheckboxField.defaultProps = {
  label: '',
  className: '',
  labelClassName: '',
  errorPlacement: 'bottom',
};

export default withStyles(styles)(CheckboxField);



// WEBPACK FOOTER //
// ./src/components/fields/CheckboxField.js